export const PRICING_SUB_TITLE_V2 = "sub_title_v2";

export const FORCE_TALK_TO_SALES = "talk_to_sales";
